import { render, staticRenderFns } from "./Administration.view.vue?vue&type=template&id=7d32faf7&"
import script from "./Administration.view.vue?vue&type=script&lang=js&"
export * from "./Administration.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports